import { createReducer, on } from '@ngrx/store';

import * as PermissionsActions from '../actions/permissions.action';

export interface PermissionState {
  accounts: any;
  units: any;
  loadedAccounts: boolean;
  loadedUnits: boolean;
  loadingAccounts: boolean;
  loadingUnits: boolean;
}

export const initialState: PermissionState = {
  accounts: {},
  units: {},
  loadedAccounts: false,
  loadedUnits: false,
  loadingAccounts: false,
  loadingUnits: false
};

const permissionsReducer = createReducer(
  initialState,
  on(PermissionsActions.loadAccountsPermissions, state => ({ ...state, loadingAccounts: true })),
  on(PermissionsActions.loadAccountsPermissionsSuccess, (state, { payload }) => {
    const accounts = payload;
    return { ...state, loadingAccounts: false, loadedAccounts: true, accounts };
  }),
  on(PermissionsActions.loadAccountsPermissionsFail, state => ({ ...state, loadingAccounts: false, loadedUnits: false })),
  on(PermissionsActions.loadUnitsPermissions, state => ({ ...state, loadingUnits: true })),
  on(PermissionsActions.loadUnitsPermissionsSuccess, (state, { payload }) => {
    const units = payload;
    return { ...state, loadingUnits: false, loadedUnits: true, units };
  }),
  on(PermissionsActions.loadAccountsPermissionsFail, state => ({ ...state, loadingUnits: false, loadedUnits: false }))
);

export function reducer(state, action) {
  return permissionsReducer(state, action);
}

export const getPermissionsAccountsEntities = (state: PermissionState) => state?.accounts;
export const getPermissionsUnitsEntities = (state: PermissionState) => state?.units;
export const getPermissionsAccountsLoading = (state: PermissionState) => state?.loadingAccounts;
export const getPermissionsUnitsLoading = (state: PermissionState) => state?.loadingUnits;
export const getPermissionsAccountsLoaded = (state: PermissionState) => state?.loadedAccounts;
export const getPermissionsUnitsLoaded = (state: PermissionState) => state?.loadedUnits;

